import React, {Fragment, useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Navbar from './components/common/navbar/Navbar';
import Landing from './components/layout/Landing';
import Routes from './components/routing/Routes';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import {LOGOUT, LOGOUT_ADMIN} from './actions/types';

// Redux
import {Provider} from 'react-redux';
import store from './store';
import {loadUser, loadUserAdmin} from './actions/auth';
import setAuthToken from './utils/setAuthToken';
import './App.css';
import Dashboard from "./components/dashboard/Dashboard";
import Login from "./components/auth/Login";
import FooterMain from "./components/common/navbar/Footer";
import connect from "react-redux/es/connect/connect";
import {actionGetPermissions} from "./actions/profile";
import CookieConsent, {Cookies} from "react-cookie-consent";
import setAuthTokenAdmin from "./utils/setAuthTokenAdmin";

if (localStorage.vip_token) {
    // Set auth token header auth
    setAuthToken(localStorage.vip_token);
}

if (localStorage.vip_token_admin) {
    // Set auth token header auth
    setAuthTokenAdmin(localStorage.vip_token_admin);
}


const App = () => {
    useEffect(() => {
        actionGetPermissions();
        // check for token in LS
        if (localStorage.vip_token) {
            setAuthToken(localStorage.vip_token);
            setTimeout(() => store.dispatch(loadUser()), 1000)
            // store.dispatch(loadUser());
        }
        if (localStorage.vip_token_admin) {
            setAuthTokenAdmin(localStorage.vip_token_admin);
            setTimeout(() => store.dispatch(loadUserAdmin()), 1000)
            // store.dispatch(loadUser());
        }

        // store.dispatch(loadUser());

        // log user out from all tabs if they log out in one tab
        window.addEventListener('storage', () => {
            if (!localStorage.vip_token) store.dispatch({type: LOGOUT});
            if (!localStorage.vip_token_admin) store.dispatch({type: LOGOUT_ADMIN});
        });
    }, []);


    return (
        <Provider store={store}>
            <ToastContainer
                position="bottom-right"
            />
            <CookieConsent
                location="bottom"
                buttonText="Accept all cookies"
                cookieName="prime-private-network"
                style={{background: "#2B373B"}}
                buttonStyle={{color: "#FFF", background: '#FDA94F', fontSize: "13px"}}
                expires={150}
            >
                This website uses cookies to enhance the user experience.{" "}
                {/*<span style={{ fontSize: "10px" }}>This bit of text is smaller :O</span>*/}
            </CookieConsent>
            <Router>
                <Fragment>
                    {/*<Navbar/>*/}
                    <Switch>
                        <Route exact path="/" component={Login}/>
                        <Route component={Routes}/>
                    </Switch>
                    <FooterMain/>
                </Fragment>
            </Router>
        </Provider>
    );
};

export default App
